import { createFormAction } from "redux-form-saga";
export const POLICY_FORM_KEY = "POLICY_FORM_KEY";
export const PolicyFormAction = createFormAction(POLICY_FORM_KEY);

